<template>
  <div class="PageGuard">
    <PageHeaderMobile :pageHeaderTitle="pageHeaderTitle" @goBack="goBack"></PageHeaderMobile>
    <Tabs :tabsData="tabsData" :active="activeTab" @tabClick="getActiveTab" v-if="infoData.reserveData">
      <div slot="basisInfo">
        <GuardBasicInfo :infoData="infoData" @linkClick="switchToInspectorForm"></GuardBasicInfo>
      </div>
      <div slot="detailInfo">
        <GuardDetailedInfo :infoData="infoData"></GuardDetailedInfo>
      </div>
      <div slot="inspectorForm">
        <Collapse :collapseData="collapseData" :active="activeCollapse" @collapseClick="getActiveCollapse">
          <div slot="entering">
            <Guard1InspectorForm
              :editable="false"
              :inspectData="infoData.inspectData.enteringInspectRecord"
              :checkItemspectData="infoData.inspectData.enteringCheckItems"
              :reserveRegion="infoData.reserveData.reserveRegion"
              :reserveArea="infoData.reserveData.reserveArea"
            >
            </Guard1InspectorForm>
          </div>
          <div slot="in1">
            <Guard2InspectorForm :isView="true" :reserveInfo="infoData" @releaseListClick="goReleaseListPage">
            </Guard2InspectorForm>
          </div>
          <div slot="in2">
            <Guard3InspectorForm :isView="true" :reserveInfo="infoData" @releaseListClick="goReleaseListPage">
            </Guard3InspectorForm>
          </div>
        </Collapse>
      </div>
    </Tabs>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import PageHeaderMobile from "@/components/common/PageHeaderMobile.vue"
import Tabs from "@/components/common/Tabs.vue"
import Collapse from "@/components/common/Collapse.vue"
import GuardBasicInfo from "@/components/Guard/GuardBasicInfo.vue"
import GuardDetailedInfo from "@/components/Guard/GuardDetailedInfo.vue"
import Guard1InspectorForm from "@/components/Guard/Guard1InspectorForm.vue"
import Guard2InspectorForm from "@/components/Guard/Guard2InspectorForm.vue"
import Guard3InspectorForm from "@/components/Guard/Guard3InspectorForm.vue"

export default {
  name: "PageGuardAll",
  props: {
    reserveID: {
      type: Number,
      default: -1,
    },
    station: {
      type: String,
    },
  },
  components: {
    PageHeaderMobile,
    Tabs,
    Collapse,
    GuardBasicInfo,
    GuardDetailedInfo,
    Guard1InspectorForm,
    Guard2InspectorForm,
    Guard3InspectorForm,
  },
  data() {
    return {
      reserveDataID: -1,
      pageHeaderTitle: "",
      activeTab: "basisInfo",
      activeCollapse: ["entering", "in1", "in2"],
      infoData: {},
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.reserveDataID = this.reserveID
      if (this.reserveDataID === -1) {
        this.reserveDataID = parseInt(window.sessionStorage.getItem("guardall_reserveID"))
      } else {
        window.sessionStorage.setItem("guardall_reserveID", this.reserveDataID)
      }
      this.getReserveInfo()
    },
    goBack() {
      let guardTempQueryParams = window.sessionStorage.getItem("guardTempQueryParams")
      window.sessionStorage.removeItem("guardTempQueryParams")
      window.sessionStorage.setItem("guardQueryParams", guardTempQueryParams)
      this.$router.push({
        name: "PageGuardReservation",
      })
    },
    getActiveTab(val) {
      this.activeTab = val
    },
    getActiveCollapse(val) {
      this.activeCollapse = val
    },
    getReserveInfo() {
      api
        .apiGetReserveInfo({ params: { id: this.reserveDataID } })
        .then((response) => {
          this.infoData = response.data.result
          this.pageHeaderTitle = response.data.result.reserveData.reserveNo
        })
        .catch((error) => {
          console.log(error)
        })
    },
    switchToInspectorForm(collapseName) {
      this.activeTab = "inspectorForm"
      this.activeCollapse = [collapseName]
    },
    goReleaseListPage() {
      let guardTempReleaseParams = {
        reserveDataID: this.reserveDataID,
        station: "PageGuardReservation_all",
      }
      window.sessionStorage.setItem("guardTempReleaseParams", JSON.stringify(guardTempReleaseParams))
      this.$router.push({
        name: "PageGuardReservationReleaseList",
        params: { reserveID: this.reserveDataID },
      })
    },
  },
  computed: {
    tabsData() {
      return [
        {
          name: "basisInfo",
          label: this.$t("pages.wording.basisInfo"),
        },
        {
          name: "detailInfo",
          label: this.$t("pages.wording.detailInfo"),
        },
        {
          name: "inspectorForm",
          label: this.$t("pages.wording.inspectorForm"),
        },
      ]
    },
    collapseData() {
      return [
        {
          title: this.$t("pages.wording.entering"),
          name: "entering",
        },
        {
          title: this.$t("pages.wording.in1"),
          name: "in1",
        },
        {
          title: this.$t("pages.wording.in2"),
          name: "in2",
        },
      ]
    },
  },
}
</script>
<style scoped>
.PageGuard {
  margin: 0 -20px -20px -20px;
  padding-top: 20px;
}
.PageGuard.edit {
  padding-bottom: 20px;
}
.Tabs ::v-deep .el-collapse-item:last-child .el-collapse-item__content {
  padding-bottom: 4px;
}
</style>
